import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpService } from '../http.service';
import { HelperService } from '../helper.service';
import { HttpClient } from '@angular/common/http';
import * as XLSX from 'xlsx';
import { HttpFileService } from '../http-file.service';
const EXCEL_TYPE =
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.csv';
import * as FileSaver from 'file-saver';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class BookAppointementService {
  constructor(
    private httpService: HttpService,
    public helperService: HelperService,
    public httpClient: HttpClient,
    private router: Router,
    private httpFileService: HttpFileService
  ) {}

  getAddresses(payload: any) {
    return this.httpService.post(`admin/user/user_get_address`, payload);
  }

  addAppointmentPlatform(payload: any) {
    return this.httpService.post(`admin/appointment-platform/create`, payload);
  }
  addPatientGroup(payload: any) {
    return this.httpService.post(`admin/patient-group/create`, payload);
  }

  createAppointmentForm(payload: any) {
    return this.httpService.post(`admin/user/appointment/book`, payload);
  }
  
  appointmentList(payload: any) {
    return this.httpService.post(`admin/user/appointment/list`, payload);
  }

  searchPatient(payload: any) {
    return this.httpService.post(`admin/user/search_list_appointment`, payload);
  }

  statusChangeList(payload:any){
    return this.httpService.post('admin/user/appointment/status-change-list', payload)
  }

  statusAllList(payload:any = ''){
    return this.httpService.post('admin/user/appointment/status-all-list', payload)
  }
  
  updateStatus(payload:any = ''){
    return this.httpService.post('admin/user/appointment/update-status', payload)
  }

  getAppointmentBasicData(payload: any) {
    return this.httpService.post(
      `admin/user/appointment/getbasicdata`,
      payload
    );
  }

  private urlAppointment = new Subject<any>();
  getCurrentUrlAppointment = this.urlAppointment.asObservable();

  setUrlWithAppointment(obj: any) {
    this.urlAppointment.next(obj)
  }
}
